import { Box, CircularProgress, SxProps, Theme } from '@mui/material'

export interface LoaderProps {
  containerStyle?: SxProps<Theme>
  style?: SxProps<Theme>
  absolute?: boolean
  size?: number
}

export const Loader = ({ containerStyle, style, absolute = false, size = 40 }: LoaderProps) => (
  <Box
    sx={{
      zoom: 0.7,
      display: 'flex',
      height: '100%',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      ...(absolute ? { position: 'absolute' } : {}),
      ...containerStyle
    }}
  >
    <CircularProgress sx={style} size={size} />
  </Box>
)
